import React from "react";
import { Map } from "immutable";
import PropTypes from "prop-types";

const PermissionContext = React.createContext({});
const PermissionContextManager = ({
    permission,
    propsPermissions
}) => Component =>
    class extends React.Component {
        render() {
            const propsPermissionsMap = new Map(propsPermissions || {})
                .map(_ => this.context.get(_))
                .filter((_, k) => ((this.props.isUserAllowedToEdit && k.includes("edit")) || !k.includes("edit")))
                .toJS();
            if (
                this.context.get(permission || this.props.permission) ||
                this.props.noPermissionRequired
            ) {
                return <Component {...this.props} {...propsPermissionsMap} />;
            }
            return null;
        }
        static displayName = "PermissionContextConsumer";
        static contextType = PermissionContext;
        static propTypes = {
            permission: PropTypes.string,
            isUserAllowedToEdit: PropTypes.bool,
            noPermissionRequired: PropTypes.bool
        };
    };

const PermissionContextProvider = PermissionContext.Provider;
const PermissionContextConsumer = PermissionContext.Consumer;

export {
    PermissionContextProvider,
    PermissionContextManager,
    PermissionContextConsumer
};
